import { fetchAPI } from "../../utils/api";

const countriesRes = fetchAPI(`/SignUpCountryList`, "GET", null, null);

const craveProvincesRes = fetchAPI(`/CraveTypesProvince`, "GET", null, null);

const banksListRes = fetchAPI(`/DebitOrderBankList`, "GET", null, null);

const accountTypesRes = fetchAPI(`/DebitOrderAccountTypes`, "GET", null, null);

const officesRes = fetchAPI(
  `/SignUpFranchiseBranchList?SystemID=56`,
  "GET",
  null,
  null
);

const provincesRes = (countryId) => {
  return fetchAPI(
    `/SignUpProvinceList?countryID=${countryId}`,
    "GET",
    null,
    null
  );
};

const citiesRes = (provinceId) => {
  return fetchAPI(
    `/SignUpCityList?provinceID=${provinceId}`,
    "GET",
    null,
    null
  );
};

const restaurantsRes = (name, type, page) => {
  return fetchAPI(
    `/CraveByProvince?name=${name}&type=${type}&page=${page}`,
    "GET",
    null,
    null
  );
};

const keywordRes = (name, type, page) => {
  return fetchAPI(
    `/CraveByKeyword?name=${name}&type=${type}&page=${page}`,
    "GET",
    null,
    null
  );
};

export {
  countriesRes,
  provincesRes,
  citiesRes,
  banksListRes,
  accountTypesRes,
  craveProvincesRes,
  restaurantsRes,
  keywordRes,
  officesRes,
};